<template>
    <div class="biometrics-admin mb-3 mt-page">

        <div class="biometrics-admin__header">
            <h1>{{ $i18n.gt('HEADING_MANAGE_PATIENT_BIOMETRICS') }}</h1>

            <div class="biometrics-admin__header__buttons">
                <router-link class="link-icon btn btn-ghost-blue mr-3"
                             :to="`/biometrics/create/practiceId/${$user.practitionerPracticeId()}`">
                    {{ $i18n.gt('LABEL_ADD_RECORD') }}
                    <shs-icon name="beaker"></shs-icon>
                </router-link>
                <router-link class="btn btn-ghost-blue mr-3"
                             :to="`/biometrics/importForPractice/practiceId/${$user.practitionerPracticeId()}`">
                    {{ $i18n.gt('LABEL_BATCH_IMPORT') }}
                    <shs-icon name="spreadsheet"></shs-icon>
                </router-link>
            </div>
        </div>

        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :show-details="false"
                    :get-items="getBiometrics"
                    :filters="filters"
                    :fields="fields">

            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key == 'actions'">
                    <router-link class="btn btn-secondary btn-sm mr-2"
                                 :to="`/biometrics/update/practiceId/${practiceId}/id/${slotProps.row.item.id}`">
                        <shs-icon name="pencil"></shs-icon>
                    </router-link>
                    <b-btn size="sm"
                           variant="danger"
                           @click="deleteBiometrics(slotProps.row.item)">
                        <shs-icon name="delete"></shs-icon>
                    </b-btn>
                </div>
                <div v-else-if="slotProps.row.field.key == 'survey_id'">
                    {{ slotProps.row.item.survey_id ? 'Yes' : 'No' }}
                </div>
                <div v-else-if="slotProps.row.field.key == 'name'">
                    <strong>
                        {{ slotProps.row.item.participant ? slotProps.row.item.participant.firstname : '' }}
                        {{ slotProps.row.item.participant ? slotProps.row.item.participant.lastname : '' }}
                    </strong>
                </div>
                <div v-else-if="slotProps.row.field.key == 'dob'">
                    <strong>
                        {{
                            slotProps.row.item.participant ? slotProps.row.item.participant.dob : '' | moment('M/D/YY')
                        }}
                    </strong>
                </div>
                <div v-else-if="slotProps.row.field.key == 'created'">
                    {{ slotProps.row.item.created | moment('M/D/YY') }}
                </div>
                <div v-else-if="slotProps.row.field.key == 'values'">
                    <biometrics-summary class="mx-3"
                                        :biometrics="slotProps.row.item">
                    </biometrics-summary>
                </div>

            </template>

        </data-table>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import Utils from '@/providers/Utils'

/**
 * Page for a Practitioner to manage Biometrics for their Practice
 */
export default Vue.extend({
    name: 'BiometricsAdmin',
    props: {
        practiceId: Number,
    },
    data() {
        return {
            newItem: {
                practice_id: this.practiceId,
                code: '',
                description: '',
                cost: 0,
            },
            linkedOptions: [
                {value: true, text: 'Yes'},
                {value: false, text: 'No'},
            ],
            fields: [
                {key: 'created', sortable: true},
                {key: 'name', sortable: true, label: 'Patient'},
                {key: 'external_id', sortable: true},
                // { key: 'survey_id', sortable: true, label: 'Linked to Questionnaire' },
                {key: 'dob', sortable: true, label: 'DOB'},
                {key: 'values', sortable: true, label: 'Values'},
                {key: 'comment', sortable: true},
                {key: 'actions', sortable: false, custom: true},
            ],
        }
    },
    computed: {
        filters() {
            return {
                practice_id: {field: 'practice_id', type: 'hidden', value: this.practiceId},
                external_id: {field: 'external_id', type: 'string', value: null, label: 'Insurance ID'},
                name: {field: 'name', type: 'string', value: null, label: 'Patient'},
                dob: {field: 'dob', type: 'date', value: null, label: 'DOB'},
                comment: {field: 'comment', type: 'string', value: null, label: 'Comment'},
            }
        }
    },
    methods: {
        async getBiometrics(listParams) {
            return this.$api.getResources(this, 'biometrics', false, ['participant'], this.filters, listParams)
        },
        async deleteBiometrics(b) {
            if (await this.$bvModal.msgBoxConfirm(`Delete Biometrics record permanently from the database ?`)) {
                try {
                    await this.$api.deleteItem(this, 'biometrics', b)
                    this.$toasted.show('Record deleted', {duration: 3000})
                    this.$refs.dataTable.refresh();
                } catch (e) {
                    this.$utils.handleError(e, 'Error deleting biometrics')
                }
            }
        },
    }
})

</script>

<style lang="scss">
.biometrics-admin__header {
    margin-bottom: .5em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
}

.biometrics-admin__header__buttons {
    @media (max-width: 767px) {
        .btn:first-child {
            margin-bottom: .5em;
        }
    }
    @media (min-width: 768px) {
        display: flex;
    }
}

</style>
